export const getLayerReactions = (layer: any) => {
  if (!layer.reactions || layer.reactions.length === 0) {
    return [];
  }

  return layer.reactions.map((reaction: any) => ({
    action: reaction.action,
    trigger: reaction.trigger,
    checks:
      reaction.checks && typeof reaction.checks === 'object'
        ? reaction.checks
        : {},
  }));
};
